"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.LegacyJumpRateModelV2Factory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "uint256",
                name: "baseRatePerYear",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "multiplierPerYear",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "jumpMultiplierPerYear",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "kink_",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "owner_",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "baseRatePerBlock",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "multiplierPerBlock",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "jumpMultiplierPerBlock",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "kink",
                type: "uint256",
            },
        ],
        name: "NewInterestParams",
        type: "event",
    },
    {
        constant: true,
        inputs: [],
        name: "baseRatePerBlock",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "blocksPerYear",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "uint256",
                name: "cash",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "borrows",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "reserves",
                type: "uint256",
            },
        ],
        name: "getBorrowRate",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "uint256",
                name: "cash",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "borrows",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "reserves",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "reserveFactorMantissa",
                type: "uint256",
            },
        ],
        name: "getSupplyRate",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "isInterestRateModel",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "jumpMultiplierPerBlock",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "kink",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "multiplierPerBlock",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "uint256",
                name: "baseRatePerYear",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "multiplierPerYear",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "jumpMultiplierPerYear",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "kink_",
                type: "uint256",
            },
        ],
        name: "updateJumpRateModel",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "uint256",
                name: "cash",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "borrows",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "reserves",
                type: "uint256",
            },
        ],
        name: "utilizationRate",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "pure",
        type: "function",
    },
];
const _bytecode = "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";
class LegacyJumpRateModelV2Factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (args.length === 1) {
            super(_abi, _bytecode, args[0]);
        }
        else {
            super(...args);
        }
    }
    deploy(baseRatePerYear, multiplierPerYear, jumpMultiplierPerYear, kink_, owner_, overrides) {
        return super.deploy(baseRatePerYear, multiplierPerYear, jumpMultiplierPerYear, kink_, owner_, overrides || {});
    }
    getDeployTransaction(baseRatePerYear, multiplierPerYear, jumpMultiplierPerYear, kink_, owner_, overrides) {
        return super.getDeployTransaction(baseRatePerYear, multiplierPerYear, jumpMultiplierPerYear, kink_, owner_, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.LegacyJumpRateModelV2Factory = LegacyJumpRateModelV2Factory;
LegacyJumpRateModelV2Factory.bytecode = _bytecode;
LegacyJumpRateModelV2Factory.abi = _abi;
//# sourceMappingURL=LegacyJumpRateModelV2Factory.js.map